/**
 * Suspense fallback shown while a lazily-loaded route chunk downloads.
 * Reuses the app's violet spinner styling. The spin animation is suppressed
 * for users who prefer reduced motion (a static ring is shown instead).
 */
function RouteFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-white"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="h-8 w-8 rounded-full border-4 border-violet-200 border-t-violet-600 motion-safe:animate-spin" />
    </div>
  );
}

export default RouteFallback;
